// ============================================================
// CustomerMarkIcon — 顧客名の頭に出す「同じ顧客からの予約」の印
//
// 正: booking-platform/md/customers.md
// 判定は useCustomerFlags（顧客DB）に集約してあり、ここは描画だけを担う。
//
//   ★（金）… 別の日にも来ているお客様（リピーター）
//   ⧉（青）… 同じ日に複数台（＝グループ・別オーダーだが同一案件）
//
// 両方に該当する場合は2つ並べる。狭い列に置くので余白は最小にしてある。
// ============================================================
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import StarIcon from '@mui/icons-material/Star';
import GroupsIcon from '@mui/icons-material/Groups';
import type { CustomerMark } from '../hooks/useCustomerFlags';

interface Props {
    mark: CustomerMark | null;
    /** アイコンの大きさ(px)。行の高さに合わせて調整する */
    size?: number;
}

const CustomerMarkIcon: React.FC<Props> = ({ mark, size = 14 }) => {
    if (!mark) return null;
    const style: React.CSSProperties = {
        fontSize: size,
        verticalAlign: 'text-bottom',
        marginRight: 2,
        flexShrink: 0,
    };
    return (
        <Tooltip title={mark.label} arrow>
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                {mark.isRepeat && <StarIcon style={{ ...style, color: '#f59e0b' }} />}
                {mark.isGroup && <GroupsIcon style={{ ...style, color: '#2563eb' }} />}
            </span>
        </Tooltip>
    );
};

export default CustomerMarkIcon;
